export const getPreviousPositions = (state) => state.causesTracking.previousPositions;
export const getDotCauses = (state) => state.causesTracking.dotCauses;
export const getSeenCauses = (state) => state.causesTracking.seenCauses;
export const getVisibleCausesCount = (state) => state.causesTracking.visibleCausesCount;
